import { useEffect, useState } from "react";
import API from "../api";

const useOtDevices = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    API.getOtSignals({ devicesOnly: true }, controller.signal)
      .then((res) => setDevices(res.data?.devices ?? []))
      .catch((err) => {
        if (err.name !== "CanceledError" && err.name !== "AbortError")
          console.error("[useOtDevices] Failed to fetch OT devices:", err);
      })
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, []);

  return { devices, loading };
};

export default useOtDevices;
